var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OneColumnPage',[_c('h1',[_vm._v("Page Not Found")]),_c('v-btn',{staticClass:"mt-3",attrs:{"color":"primary","to":"/"}},[_vm._v("Take me home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }